import React from 'react';
import PropTypes from 'prop-types';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

function MobileOnlyComponent({ children }) {
  const isDesktopLayout = useIsDesktopLayout();
  return <>{isDesktopLayout ? null : children}</>;
}

MobileOnlyComponent.propTypes = {
  children: PropTypes.node.isRequired,
};
export default MobileOnlyComponent;
